
import alt from '../alt';

/**
 * Teadete kuvamise tegevused.
 * Kasutamine:
 * 
 *  import NotificationActions from './actions/NotificationActions';
 *  NotificationActions.error(message);
 *  
 */
class NotificationActions {
	constructor() {
		this.generateActions(
			'info',
			'warning',
			'success',
			'error',
			'dismiss'
		);
	}

    /**
	 * Notify about REST action error
     * @param {RestAction} action
     * @returns {RestAction}
     */
    actionError(action) {
        return action;
    }
}

/**
 *
 * @type {NotificationActions}
 */
let notificationActions = alt.createActions(NotificationActions);
export default notificationActions;
